// extracted by mini-css-extract-plugin
module.exports = {"about":"AriaMenu_about__3K3_r","accessabilityWidget":"AriaMenu_accessabilityWidget__1RVCb","menu":"AriaMenu_menu__2yaCz"};